import { outerTabStyle, tabContentContainerStyle } from '../shared/styles';
import { FieldHeaderComponent, StudyResearchTeamMemberRowsComponent } from '@vivli/shared/components';
import { useListingRequestContext } from '@vivli/features/listing-request/infrastructure/context';
import { useActiveUserContext } from '@vivli/core/infrastructure/context';
import { ListingRequestStatusEnum } from '@vivli/features/listing-request/infrastructure/enum';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';

export const InformationAboutYourTeamComponent = () => {
    const { hasPermission } = useActiveUserContext();
    const { isReadOnly, handleNext, listingRequest } = useListingRequestContext();
    const arrayName = 'datasets[0].researchTeam';
    const explanatoryText =
        'The names that you enter using "Add Team Member" will get public recognition for their contributions to the study.  You can select one or more CRediT roles - for a list of the available roles and descriptions, click on the Help icon at the top of the field.';
    //TODO PERMFE - redo with permissions+
    const datasetId =
        hasPermission(PermissionsEnum.SubmissionsActAdv) || listingRequest?.status == ListingRequestStatusEnum.Draft
            ? listingRequest?.datasets[0]?.id
            : null;
    return (
        <div style={outerTabStyle} className={'scrolly'}>
            <div style={tabContentContainerStyle}>
                <FieldHeaderComponent title={'TELL US ABOUT THE RESEARCH TEAM'} />
                <div>{explanatoryText}</div>
                <StudyResearchTeamMemberRowsComponent
                    arrayName={arrayName}
                    isReadOnly={isReadOnly}
                    showNextButton={true}
                    handleNext={() => handleNext('YourOrganization')}
                    datasetId={datasetId}
                />
            </div>
        </div>
    );
};
